import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useTranslation } from 'react-i18next';
import { colors } from 'components/styles/variables';
import { ForgotPasswordFormSchema } from 'lib/validationSchemas';
import SubmitButton from './SubmitButton';
import Separator from './Separator';
import Header from './Header';
import StageWrapper from './StageWrapper';
import { formCss, errorCss, inputCss } from './styles';

interface Props {
  onSubmit(values: { email: string }): void | Promise<void>;
}

export default function ForgotPassword({ onSubmit }: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <StageWrapper>
      <Header>
        <h1 data-testid="headline">{t('auth.resetPassword.headline')}</h1>
        <Separator />
      </Header>
      <p>{t('auth.resetPassword.description')}</p>
      <Formik
        initialValues={{ email: '' }}
        validationSchema={ForgotPasswordFormSchema}
        onSubmit={async (values, { setSubmitting }): Promise<void> => {
          await onSubmit(values);
          setSubmitting(false);
        }}
      >
        {({ isSubmitting }): JSX.Element => (
          <Form className={formCss.className}>
            <label>{t('auth.common.email')}</label>
            <Field
              type="email"
              name="email"
              placeholder="email@email.com"
              className={inputCss.className}
            />
            <div className={`error ${errorCss.className}`}>
              <ErrorMessage name="email">
                {(error): string => {
                  return t(error);
                }}
              </ErrorMessage>
            </div>
            <SubmitButton isSubmitting={isSubmitting}>
              {t('auth.resetPassword.resetPassword')}
            </SubmitButton>
          </Form>
        )}
      </Formik>
      {formCss.styles}
      {inputCss.styles}
      {errorCss.styles}
      <style jsx>{`
        label {
          color: ${colors.BLACK};
          font-size: 13px;
          font-weight: 600;
          height: 17px;
          text-align: left;
          text-transform: uppercase;
        }
      `}</style>
    </StageWrapper>
  );
}
